/**
 * The forecast grid's reads (f11.1, adr-14).
 *
 * f12.2: the live stream (`useLiveCycle`) writes pushed figures under
 * `forecastGridQueryKey()`. The 2 s refetch while a recalculation is pending
 * or a row is stale is only the FALLBACK, enabled by the page while the
 * stream has been down for more than 5 s.
 */

import { useQuery } from '@tanstack/react-query';

import { api } from '@/api/client';
import { queryKeys } from '@/api/queryKeys';

import { needsPolling } from './forecastView';

export const FORECAST_POLL_MS = 2000;

/** The grid's one query key; the live stream writes pushed figures here (f12.2). */
export const forecastGridQueryKey = queryKeys.cycle.forecastGrid;

export function useForecastUnits(cycleId: string) {
  return useQuery({
    queryKey: queryKeys.cycle.forecastUnits(cycleId),
    queryFn: () => api.listForecastGridUnits(cycleId),
    enabled: Boolean(cycleId),
  });
}

export function useForecastGrid(cycleId: string, businessUnitId: string, { poll = true }: { poll?: boolean } = {}) {
  return useQuery({
    queryKey: forecastGridQueryKey(cycleId, businessUnitId),
    queryFn: () => api.getForecastGrid(cycleId, businessUnitId),
    enabled: Boolean(cycleId && businessUnitId),
    refetchInterval: (query) => (poll && needsPolling(query.state.data) ? FORECAST_POLL_MS : false),
  });
}
